// --- 路由管理 --- //

export default [
  {
    name: 'routeList',
    path: '/platformManagement/routeManagement/routeList/list',
    meta: { title: '路由列表' },
    component: require('business/platformManagement/routeManagement/routeList/list.vue').default
  },
  {
    name: 'routeDetail',
    path: '/platformManagement/routeManagement/routeList/detail',
    meta: { title: '路由详情' },
    component: require('business/platformManagement/routeManagement/routeList/detail.vue').default
  },
  {
    name: 'routeDetail',
    path: '/platformManagement/routeManagement/richText/list',
    meta: { title: '富文本测试' },
    component: require('business/platformManagement/routeManagement/richText/list.vue').default
  }
]
